import FingerprintJS from '@fingerprintjs/fingerprintjs'
import { ApiService } from "./api.service";

/**
 * Service that handles the visitor ID, stores it in local storage and if not
 * exists creates a new one and then stores it
 */
export class VisitorIdService {

    /**
     * Returns the visitorId (fingerprint). If it exists in localStorage that
     * one is returned, otherwise it's generated and then stored in
     * localStorage for later use (before bein returned)
     *
     * @link https://github.com/fingerprintjs/fingerprintjs/
     * @returns {Promise<string>}
     */
    static async getId() {
        let visitorId = localStorage.getItem('chitchat');

        if(!visitorId) {
            const fingerprint = FingerprintJS.load();
            const fingerprintInstance = await fingerprint;
            const result = await fingerprintInstance.get();
            visitorId = result.visitorId;
            localStorage.setItem('chitchat', visitorId);
        }

        return visitorId;
    }
}
